export { getTranslatedText as t } from '@amzn/jwo-store-management-platform-components'
